export const enableInProductionOrUseLocalOverride = (property: string) => {
  if (process.env[property] !== undefined) {
    return process.env[property] === 'true';
  }
  return !!(process.env.NODE_ENV === 'production');
};
